<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card header="Editar Porteo">
          <Form :service_id="id" />
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import api from "@/helpers/api";
import moment from "moment";
import Form from './Form';
export default {
  components: { Form },
  data() {
    return {
      id: this.$route.params.id
    }
  },
  mounted() {
    
  },
};
</script>
